// @Version: 1.0.0
import { Component } from '@angular/core';
import { TRANSLATE_PATH } from '../../../shared.model';
import { TranslateService } from '@ngx-translate/core';
import { SidenavNoLoginService } from './sidenav-no-login.service';

@Component({
   selector: 'app-sidenav-no-login',
   templateUrl: './sidenav-no-login.component.html',
   standalone: false
})
export class SidenavNoLoginComponent {

   public TRANSLATE_PATH = TRANSLATE_PATH; 

   constructor (public sTranslate: TranslateService, public sSidenavNoLogin: SidenavNoLoginService) {
      this.sSidenavNoLogin.loadNav().subscribe();
   }
}
